import { IBranchNode, IEntityNode, IInlineBranchNode } from '../types';
import { UnreachableCaseError } from 'ts-essentials';
import SvgIcon from '../../../Icon/SvgIcon';
import { IStyled } from '../../../../styles/types';
import styled from 'styled-components';
import { BucketKind } from '../../../../utils/apollo/graphqlSchema';
import { theme } from '../../../../styles/theme';

interface IProps extends IStyled {
  node: IEntityNode | IBranchNode | IInlineBranchNode;
}

const MenuNodeIcon = ({ node, className }: IProps) => {
  switch (node.__typename) {
    // no icons
    case 'TagBranch':
    case 'TagLeafAnyEvent':
    case 'TagLeafAnyTableEvent':
    case 'TagLeafDateBucketDef':
    case 'TagLeafBasicEvent':

    case 'TagLeafSimpleCohort':
    case 'TagLeafCompoundCohort':
    case 'TagLeafSimpleMeasure':
    case 'TagLeafCompoundMeasure':
      return null;
    // filter
    case 'TagLeafField':
      if (node.isGeo) {
        return <SvgIcon name="chart-geo-map" className={className} />;
      } else {
        return null;
      }
    case 'TagLeafFilter':
      return <SvgIcon name="es-named-filter" className={className} />;
    case 'TagLeafVirtualEvent':
      return <SvgIcon name="es-virtual-event" className={className} />;
    // binning
    case 'TagLeafEnumBucketDef':
      return <SvgIcon name="es-enum-binning" className={className} />;
    case 'TagLeafRangeBucketDef':
      return <SvgIcon name="es-range-binning" className={className} />;
    case 'TagInlineBranch':
    case 'TagFieldInlineBranch':
      return <SvgIcon name="es-array-object" className={className} />;
    case 'TagLeafCustomBucketDef':
      switch (node.kind) {
        case BucketKind.Enum:
          return <SvgIcon name="es-enum-binning" className={className} />;
        case BucketKind.Range:
          return <SvgIcon name="es-range-binning" className={className} />;
        case BucketKind.Date:
          return <>[DB]</>;
        default:
          throw new UnreachableCaseError(node.kind);
      }
    default:
      throw new UnreachableCaseError(node);
  }
};

export const MenuItemIcon = styled(MenuNodeIcon)`
  min-width: 16px;
  min-height: 16px;
`;

const DescriptionNodeIcon = ({ node, className }: IProps) => {
  switch (node.__typename) {
    // no icons
    case 'TagBranch':
    case 'TagLeafAnyEvent':
    case 'TagLeafAnyTableEvent':
    case 'TagLeafDateBucketDef':
      return null;
    case 'TagLeafField':
      if (node.isGeo) {
        return <SvgIcon name={'chart-geo-map'} className={className} />;
      }
      return <SvgIcon name="es-field" className={className} />;
    // filter
    case 'TagLeafFilter':
      return <SvgIcon name="es-named-filter" className={className} />;
    // events
    case 'TagLeafBasicEvent':
      return <SvgIcon name="es-basic-event" className={className} />;
    case 'TagLeafVirtualEvent':
      return <SvgIcon name="es-virtual-event" className={className} />;
    // cohorts
    case 'TagLeafSimpleCohort':
    case 'TagLeafCompoundCohort':
      return <SvgIcon name="es-cohort" className={className} />;
    // measures
    case 'TagLeafSimpleMeasure':
    case 'TagLeafCompoundMeasure':
      return <SvgIcon name="es-measure" className={className} />;
    // binning
    case 'TagLeafEnumBucketDef':
      return <SvgIcon name="es-enum-binning" className={className} />;
    case 'TagLeafRangeBucketDef':
      return <SvgIcon name="es-range-binning" className={className} />;
    case 'TagInlineBranch':
    case 'TagFieldInlineBranch':
      return <SvgIcon name="es-array-object" className={className} />;
    case 'TagLeafCustomBucketDef':
      switch (node.kind) {
        case BucketKind.Enum:
          return <SvgIcon name="es-enum-binning" className={className} />;
        case BucketKind.Range:
          return <SvgIcon name="es-range-binning" className={className} />;
        case BucketKind.Date:
          return <>[DB]</>;
        default:
          throw new UnreachableCaseError(node.kind);
      }
    default:
      throw new UnreachableCaseError(node);
  }
};

export const DescriptionIcon = styled(DescriptionNodeIcon)`
  width: 16px !important;
  height: 16px !important;
  color: ${theme.colors.mainBlue};
  fill: ${theme.colors.mainBlue};
`;
